import React, { useEffect, useState } from 'react';

import * as tnaServices from '../../../../../services/tnaServices';
import css from './TnaEditQuestions.module.css';

import AddEditForm from '../../../_common/elements/forms/AddEditForm';

function TnaEditQuestions({ setEditAtaQuestions, ataId, tnaDetails }) {
    const [mcq, setMcq] = useState(0);

    useEffect(() => {
        const ataQuestions = tnaDetails?.mcq.find((x) => x.ataId === ataId && x.tnaId === tnaDetails?.tnaId);
        if (ataQuestions) {
            setMcq(ataQuestions.mcqQty);
        }
    }, [ataId, tnaDetails]);

    const handleSave = (e) => {
        e.preventDefault();
        // Save logic here
        const tnaMcqId = tnaDetails?.mcq.find((x) => x.ataId === ataId && x.tnaId === tnaDetails?.tnaId)?.tnaMcqId;
        const updatedMcq = {
            ataId,
            mcqQty: mcq,
            tnaId: tnaDetails?.tnaId,
            tnaMcqId,
        };

        tnaServices
            .updateMcqQuestions(updatedMcq)
            .then((response) => {
                console.log('MCQ questions updated successfully:', response.data);
            })
            .catch((err) => console.error('Error updating MCQ questions:', err));

        setEditAtaQuestions(0);
    };

    const handleClose = (e) => {
        e.preventDefault();
        setEditAtaQuestions(0);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSave(e);
        }
        if (e.key === 'Escape') {
            handleClose(e);
        }
        if (e.key === 'Up' || e.key === 'Down') {
            e.preventDefault();
            const newValue = e.key === 'Up' ? mcq + 1 : mcq - 1;
            setMcq(Math.max(0, newValue));
        }
    };

    return (
        <AddEditForm>
            <div className={css.form} onKeyDown={handleKeyDown}>
                {/* <h2>
                    Edit Questions for ATA ID: {ataId} and TNA ID: {tnaDetails?.tnaDetails?.tnaId}
                </h2> */}
                {/* Your form elements and logic go here */}
                <label htmlFor="mcq" className={css.label}>MCQ Quantity:</label>
                <input
                    id="mcq"
                    type="number"
                    value={mcq}
                    onChange={(e) => setMcq(e.target.value)}
                    className={css.input}
                />

                <div className={css.submitButtons}>
                    <button onClick={handleSave} className={`${css.greenButton}`}>
                        Save
                    </button>
                    <button onClick={handleClose} className={`${css.redButton}`}>
                        Close
                    </button>
                </div>
            </div>
        </AddEditForm>
    );
}
export default TnaEditQuestions;
